export type CalculateStrategyModel = 'amount-installment' | 'amount-duration';
